import { api } from '@/lib/axios';

export interface QuickSaleAddress {
  zipCode: string | null;
  address: string | null;
  number: string | null;
  complement: string | null;
  neighborhood: string | null;
  city: string | null;
  state: string | null;
}

export interface QuickSaleClient {
  id: string;
  name: string;
  email: string | null;
  phone: string | null;
  document: string | null;
  address: QuickSaleAddress;
  category: {
    id: string;
    name: string;
    discount: number;
  } | null;
}

export interface QuickSaleProduct {
  id: string;
  name: string;
  description: string | null;
  sku: string | null;
  brand: string | null;
  price: number;
  finalPrice: number;
  discount: number;
  stock: number | null;
  category: string | null;
  image: string | null;
}

export interface QuickSaleData {
  client: QuickSaleClient;
  product: QuickSaleProduct;
}

export const quickSaleService = {
  async getQuickSaleData(clientId: string, productId: string): Promise<QuickSaleData> {
    const { data } = await api.get(`/quick-sale/${clientId}/${productId}`);
    return data;
  },

  async getQuickSaleDataBySku(clientId: string, productSku: string): Promise<QuickSaleData> {
    const { data } = await api.get(`/quick-sale/sku/${clientId}/${productSku}`);
    return data;
  },
};
